import { ref } from 'vue';
import axios from '@/services/useAxios';

export default function () {
    const subscription = ref(null);

    const createSubscription = async (data) => {
        const res = await axios.post('/notifications/subscriptions', data);
        if (res.status === 201) {
            subscription.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const getSubscription = async (id) => {
        const res = await axios.get(`/notifications/subscriptions/${id}`);
        if (res.status === 200) {
            subscription.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const updateSubscription = async (id, data) => {
        const res = await axios.put(`/notifications/subscriptions/${id}`, data);
        if (res.status === 200) {
            subscription.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const deleteSubscription = async (id) => {
        const res = await axios.delete(`/notifications/subscriptions/${id}`);
        if (res.status === 200) {
            subscription.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    return {
        subscription,
        createSubscription,
        getSubscription,
        updateSubscription,
        deleteSubscription,
    };
}
